import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgressBarService {
  private progressSubject = new BehaviorSubject<boolean>(false);

  /**
     * Show or hide the progress bar.
     * @param show - true to show, false to hide
     */
  show(show: boolean): void {
    Promise.resolve().then(() => this.progressSubject.next(show));
  }

  /**
   * Hide the progress bar.
   */
  hide(): void {
    Promise.resolve().then(() => this.progressSubject.next(false));
  }

  /**
   * Observable indicating whether the progress bar is active.
   */
  isActive(): Observable<boolean> {
    return this.progressSubject.asObservable();
  }
}
